const { liveActionTypes } = require("./actionTypes");

export const setStatus = (status) => ({
  type: liveActionTypes.SET_STATUS,
  status,
});

export const setWSReference = (wsObj) => ({
  type: liveActionTypes.SET_WS_REF,
  wsObj,
});

export const receiveMessage = (data) => ({
  type: liveActionTypes.RECEIVE_MESSAGE,
  data,
});
export const contestReceiveMessage = (data) => ({
  type: liveActionTypes.CONTEST_RECEIVE_MESSAGE,
  data,
});

export const clearData = () => ({
  type: liveActionTypes.CLEAR_DATA,
});

export const clearContestData = () => ({
  type: liveActionTypes.CONTEST_CLEAR_DATA,
});
